import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=33764fce&scoped=true&lang=pug&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=33764fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33764fce",
  null
  
)

export default component.exports